import { toggleFilterTrigger } from "./toggleFilterTriggerInHeader";
import { calculateHeaderVisibleHeight } from "Functions/window";
import { checkResolution } from "Functions/helpers";

class StickyScrollingHeader {
    get direction() {
        let direction = this.lastPosition > this.position ? "up" : "down";

        if (this.lastPosition == this.position) {
            direction = this.lastDirection;
        }

        return direction;
    }

    get position() {
        return window.scrollY;
    }

    get isNavigationOpen() {
        return document.getElementById("navigation")?.classList.contains("is-active");
    }

    get isHeaderDropdownOpen() {
        return document.querySelector(".c-header-main__trigger.is-active") !== null;
    }

    get isSearchOpen() {
        return document.querySelector(".c-header-main__search.is-form-visible") !== null;
    }

    get isMobile() {
        return checkResolution("cxs;xs");
    }

    constructor(headerElSelector) {
        this.timeout = null;
        this.animationTimeout = null;
        this.lastPosition = 0;
        this.lastDirection = null;
        this.navigationJustClosed = false;
        this.dropdownJustClosed = false;
        this.searchJustClosed = false;
        this.headerEl = document.querySelector(headerElSelector);

        if (this.headerEl) {
            window.addEventListener("scroll", this.handleScroll.bind(this));
        }

        // Listen for navigation close to sync position
        const navigation = document.getElementById("navigation");
        if (navigation) {
            navigation.addEventListener("rToggle.afterClose", () => {
                this.navigationJustClosed = true;
                this.lastPosition = this.position;
                this.lastDirection = "up";

                setTimeout(() => {
                    this.navigationJustClosed = false;
                }, 200);
            });
        }

        for (const id of ["navigation", "navigation-featured"]) {
            const toggle = document.getElementById(id);

            if (!toggle) {
                continue;
            }

            for (const event of ["rToggle.afterOpen", "rToggle.afterClose"]) {
                toggle.addEventListener(event, () => {
                    calculateHeaderVisibleHeight();
                });
            }
        }

        // Listen for header dropdown close to sync position
        const accountMenu = document.getElementById("account-menu");
        if (accountMenu) {
            accountMenu.addEventListener("rToggle.afterClose", () => {
                this.dropdownJustClosed = true;
                this.lastPosition = this.position;
                this.lastDirection = "up";

                setTimeout(() => {
                    this.dropdownJustClosed = false;
                }, 200);
            });
        }

        // Listen for search autocomplete close
        if (typeof window.rEvent?.on === "function") {
            window.rEvent.on("Autocomplete.hide", () => {
                this.searchJustClosed = true;
                this.lastPosition = this.position;
                this.lastDirection = "up";

                setTimeout(() => {
                    this.searchJustClosed = false;
                }, 200);
            });
        }

        this.handleScroll();
    }

    handleScroll(event) {
        if (this.timeout) return;

        this.timeout = setTimeout(this.recalculateScrollDirection.bind(this), 150);
    }

    setScrollingUp(show) {
        const wasScrollingUp = this.headerEl.classList.contains("is-scrolling-up");

        // If transitioning from scrolling-up to normal
        if (wasScrollingUp && !show) {
            // When returning to top, skip the animation class and show header bottom with slide
            if (this.position === 0) {
                this.headerEl.classList.add("is-header-bottom-appearing");
                clearTimeout(this.animationTimeout);
                this.animationTimeout = setTimeout(() => {
                    this.headerEl.classList.remove("is-header-bottom-appearing");
                }, 200);
            } else {
                // Normal transition - add animation class
                this.headerEl.classList.add("is-scrolling-up-animation");
                clearTimeout(this.animationTimeout);
                this.animationTimeout = setTimeout(() => {
                    this.headerEl.classList.remove("is-scrolling-up-animation");
                }, 200);
            }
        }

        this.headerEl.classList.toggle("is-scrolling-up", show);
    }

    recalculateScrollDirection() {
        calculateHeaderVisibleHeight();

        if (this.isMobile) {
            this.headerEl.classList.remove("is-scrolling-up");
            toggleFilterTrigger(true);

            this.lastPosition = this.position;
            this.lastDirection = this.direction;
            this.timeout = null;

            return;
        }

        // Skip recalculation when navigation/dropdown/search is open or just closed
        if (
            this.isNavigationOpen ||
            this.isHeaderDropdownOpen ||
            this.isSearchOpen ||
            this.navigationJustClosed ||
            this.dropdownJustClosed ||
            this.searchJustClosed
        ) {
            const shouldKeepHeaderVisible =
                this.headerEl.classList.contains("is-scrolling-up") || this.position > 0;

            this.headerEl.classList.toggle("is-scrolling-up", shouldKeepHeaderVisible);
            toggleFilterTrigger(!shouldKeepHeaderVisible);

            this.timeout = null;

            return;
        }

        if (window.isAnchorScrolling) {
            this.setScrollingUp(false);
            toggleFilterTrigger(true);
        } else {
            const shouldShow = this.direction == "up" && this.position > 0;
            this.setScrollingUp(shouldShow);
            toggleFilterTrigger(!shouldShow);
        }

        this.lastPosition = this.position;
        this.lastDirection = this.direction;
        this.timeout = null;
    }
}

new StickyScrollingHeader(".js-page-header");
